import { ErrorBoundary } from "components/ErrorBoundary";
import { InputSidebarContainer } from "components/PantallasEdit/InputContainer/InputSideBarContainer";
import { Form } from "react-bootstrap";
import { FormHelper, StyleHelper } from "utils";
import Select from "react-select";
import { PhoneInput } from "components/PhoneInput/PhoneInput";
import { EmailInput } from "components/EmailInput/EmailInput";

export const SideInput = ({
  type = "text",
  label = "",
  placeholder = "",
  onChange,
  required = false,
  setState = () => { },
  name = "text",
  value = "",
  disabled = false,
  options = [],
  multiple = false,
  isClearable = false,
  hideType: hidePhoneType = false,
  styleControl = {},
  styleMenu = {},
  maxLength = null,
  min = null,
  max = null
}) => {
  const inputStyle = { padding: "0px", marginTop: "5px" };
  const requiredInputStyle = required ? { borderLeft: "3px solid red" } : {};
  const requiredSelectStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      ...(required ? StyleHelper.InputRequired : {}),
      ...styleControl,
    }),
    menu: (provided) => ({
      ...provided,
      ...styleMenu,
    }),
  };

  const renderInput = () => {
    switch (type.toLowerCase()) {
      case "switch":
        return (
          <Form.Check
            id={`form-check-switch-${name}`}
            type="switch"
            label={placeholder}
            checked={!!value}
            disabled={disabled}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              } else {
                setState((prev) => ({
                  ...prev,
                  [name]: e.target.checked,
                }));
              }
            }}
            style={requiredInputStyle}
          />
        );

      case "check":
        return (
          <Form.Check
            id={`form-check-${name}`}
            type="checkbox"
            label={placeholder}
            checked={!!value}
            disabled={disabled}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              } else {
                setState((prev) => ({
                  ...prev,
                  [name]: e.target.checked,
                }));
              }
            }}
            style={requiredInputStyle}
          />
        );

      case "color":
        return (
          <Form.Control
            disabled={disabled}
            onChange={(e) => FormHelper.handleChange(e, setState)}
            name={name}
            placeholder={placeholder}
            type="color"
            value={value ?? "#000000"}
          />
        );

      case "select":
        return (
          <Select
            placeholder={placeholder}
            isDisabled={disabled}
            className={multiple ? "basic-multi-select" : "react-select primary"}
            classNamePrefix="react-select"
            name={name}
            isMulti={multiple}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              } else {
                if (multiple) {
                  setState((prev) => ({
                    ...prev,
                    [name]: e ? e.map((option) => option.value) : [],
                  }));
                } else {
                  setState((prev) => ({
                    ...prev,
                    [name]: e?.value,
                  }));
                }
              }
            }}
            options={options || []}
            value={options.filter(function (option) {
              return Array.isArray(value)
                ? value.includes(option.value)
                : option.value === value;
            })}
            styles={requiredSelectStyle}
          />
        );

      case "number":
        return (
          <Form.Control
            disabled={disabled}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              } else {
                FormHelper.handleChange(e, setState);
              }
            }}
            name={name}
            type="number"
            value={value || ""}
            min={min}
            max={max}
            style={requiredInputStyle}
            placeholder={placeholder}
          />
        );

      case "text":
        return (
          <Form.Control
            disabled={disabled}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              } else {
                FormHelper.handleChange(e, setState);
              }
            }}
            name={name}
            type="text"
            value={value || ""}
            style={requiredInputStyle}
            placeholder={placeholder}
          />
        );

      case "textarea":
        return (
          <Form.Control
            disabled={disabled}
            onChange={(e) => FormHelper.handleChange(e, setState)}
            value={value || ""}
            name={name}
            as="textarea"
            rows={2}
            placeholder={placeholder}
            style={requiredInputStyle}
          />
        );

      case "phone":
        return (
          <PhoneInput
            required={required}
            initialValue={value}
            hideType={hidePhoneType}
            onChange={(tels) =>
              setState((prev) => ({
                ...prev,
                [name]: tels,
              }))
            }
          />
        );

      case "email":
        return (
          <EmailInput
            required={required}
            inputValue={value}
            placeholder={placeholder || "Correo Electrónico"}
            parentCallback={(e) => {
              setState((prev) => ({ ...prev, [name]: e }));
            }}
          />
        );

      case "password":
        return (
          <Form.Control
            disabled={disabled}
            onChange={(e) => FormHelper.handleChange(e, setState)}
            name={name}
            placeholder={placeholder}
            type="password"
            value={value ?? ""}
            maxLength={maxLength}
          />
        );
    }
  };

  return (
    <ErrorBoundary>
      <InputSidebarContainer label={label} style={inputStyle}>
        {renderInput()}
      </InputSidebarContainer>
    </ErrorBoundary>
  );
};
